<template>
  <div>
    <!-- ===== PC版 ===== -->
    <template v-if="isDesktop">
      <header id="header-index" class="header" v-if="!isNative">
        <div class="container-wide">
          <div class="header__inner">
            <!-- ロゴ左配置 -->
            <div class="header__left">
              <a href="/" v-if="isShowGlobalNav">
                <img
                  src="/travelist/pc/img/logo_header.svg"
                  alt="Travelist（トラベリスト）"
                  height="auto"
                  width="150"
                />
              </a>
              <span v-else>
                <img
                  src="/travelist/pc/img/logo_header.svg"
                  alt="Travelist（トラベリスト）"
                  height="auto"
                  width="150"
                />
              </span>
              <span v-if="isAgent" class="agent-label">AGT版</span>
              <h1 class="header__desc">
                格安航空券・飛行機チケット・LCC予約
              </h1>
            </div>

            <!-- ナビリンク右配置 -->
            <div class="header__right" v-if="isShowGlobalNav">
              <cart-icon v-show="isShowCartIcon"></cart-icon>
              <a href="/mypage/points" class="point-link" v-if="isLoggedIn">
                <img
                  src="/travelist/sp/img/icon/point_icon_new.png"
                  alt="point_icon"
                />
                <span>{{
                  user ? (user.points_remain ?? 0).toLocaleString() : 0
                }}</span
                >P
              </a>
              <div v-if="!isLoggedIn && !isFromMetaSearch">
                <div class="point-link-wrap">
                  <button
                    type="button"
                    class="point-link border-none"
                    @click="showPointModal"
                  >
                    <img
                      src="/travelist/sp/img/icon/point_icon_new.png"
                      alt="point_icon"
                    />
                    <span>ポイント</span>
                  </button>
                  <header-point-modal
                    v-show="isShowPointModal"
                    @closePointModal="closePointModal"
                  ></header-point-modal>
                </div>
              </div>
              <div class="dd_menu">
                <a class="btn-txt btn-txt--usage" href="/support/flow"
                  >ご利用方法</a
                >
                <div class="dd_menu__nav">
                  <a class="dd_menu__nav__item" href="/support/flow"
                    >ご利用の流れ</a
                  >
                  <a
                    class="dd_menu__nav__item"
                    href="https://tayori.com/faq/790c65b095252e9628baebfe559b377e5e73f8c9/"
                    target="_blank"
                    rel="noopener noreferrer"
                    >よくあるご質問</a
                  >
                  <a class="dd_menu__nav__item" href="/support/cancel"
                    >キャンセル・変更に関して</a
                  >
                  <a class="dd_menu__nav__item" href="/contact">お問い合わせ</a>
                </div>
              </div>
              <a class="btn-txt" href="/application/list">予約確認</a>
              <div class="divide"></div>
              <a class="btn-txt" v-show="!isLoggedIn" href="/s/member/register"
                >新規会員登録</a
              >
              <a class="btn btn--signin" v-show="!isLoggedIn" href="/login"
                >ログイン</a
              >
              <div class="dd_menu" v-show="isLoggedIn">
                <a
                  class="btn-txt btn-txt--user btn-txt--usage btn-txt--mypage"
                  href="/mypage/"
                  >{{ fullName }}<span>様</span></a
                >
                <div class="dd_menu__nav">
                  <a class="dd_menu__nav__item" href="/mypage/"
                    ><i class="fa-solid fa-user"></i>マイページ</a
                  ><a class="dd_menu__nav__item" href="/s/member/edit"
                    ><i class="fa-solid fa-file-pen"></i>会員情報の確認・変更</a
                  ><a class="dd_menu__nav__item" href="/login.php?mem_logout=1"
                    ><i class="fa-solid fa-right-from-bracket"></i>ログアウト</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <grobal-nav
        v-if="isShowGlobalNav && isShowPcGlobalNav && !isNative"
      ></grobal-nav>
    </template>

    <!-- ===== SP版 ===== -->
    <template v-else>
      <header :class="{ opened: isMenuOpenedInner }" v-if="!isNative">
        <button
          class="menu-button"
          @click="isMenuOpenedInner = !isMenuOpenedInner"
          aria-label="メニュー"
          v-if="isShowGlobalNav"
        >
          <span class="menu-button-icon"></span>
        </button>
        <div class="header">
          <div class="heading-point" v-if="user && isShowGlobalNav">
            <a class="user-point" href="/mypage/points">
              <img
                src="/travelist/sp/img/icon/point_icon_new.png"
                alt="point_icon"
                width="10"
                height="10"
              />
              <span>{{ user ? user.points_remain : 0 }}</span
              >pt
            </a>
          </div>
          <div
            class="heading-point"
            v-if="!user && !isFromMetaSearch && isShowGlobalNav"
          >
            <button
              type="button"
              class="user-point bg-transparent border-none p-0 cursor-pointer"
              @click="showPointModal"
            >
              <img
                src="/travelist/sp/img/icon/point_icon_new.png"
                alt="point_icon"
              />
              <span>ポイント</span>
            </button>
          </div>
          <header-point-modal
            v-show="isShowPointModal"
            @closePointModal="closePointModal"
          ></header-point-modal>
          <cart-icon v-if="isShowCartIcon"></cart-icon>
          <a class="header-logo2 box-content" href="/" v-if="isShowGlobalNav">
            <img
              class="h-auto"
              src="/travelist/pc/img/logo_header.svg"
              alt="トラベリスト -Travelist- 格安航空券の検索・予約"
              width="104px"
              height="31"
            />
          </a>
          <span class="header-logo2 box-content" v-else>
            <img
              class="h-auto"
              src="/travelist/pc/img/logo_header.svg"
              alt="トラベリスト -Travelist- 格安航空券の検索・予約"
              width="104px"
              height="31"
            />
          </span>
        </div>
        <div class="overlay" @click="isMenuOpenedInner = false"></div>
        <nav class="nav2">
          <ul class="header-menu">
            <li>
              <div v-if="user">
                <div class="nav-title">
                  会員メニュー
                  <a class="user-point" href="/mypage/points">
                    <img
                      src="/travelist/sp/img/icon/point_icon_new.png"
                      alt="point_icon"
                    />
                    <span>{{ user ? user.points_remain : 0 }}</span
                    >pt
                  </a>
                </div>
                <a :href="headerRankLink" class="headerRank headerRank--menu">
                  <div class="headerRank__rank">
                    <div class="headerRank__rankName">
                      会員ランク：<span class="font-bold">{{ rankName }}</span>
                    </div>
                    <div class="headerRank__rankImage">
                      <img :src="rankImage" :alt="rankName" />
                    </div>
                  </div>
                </a>
                <dl class="list-menu2">
                  <dt class="mypage">
                    <p>こんにちは！</p>
                    <span class="user-name2">{{ fullName }}</span
                    >様
                  </dt>
                  <dd>
                    <a class="link-icon" href="/mypage/">
                      <i class="fa-solid fa-user"></i><span>マイページ</span>
                    </a>
                    <a class="link-icon" href="/s/member/edit">
                      <i class="fa-solid fa-file-pen"></i
                      ><span>会員情報の確認・変更</span>
                    </a>
                    <a class="link-icon" href="/application/list">
                      <i class="fa-solid fa-calendar-check"></i
                      ><span>予約確認</span>
                    </a>
                    <a class="link-icon" href="/login.php?mem_logout=1">
                      <i class="fa-solid fa-right-from-bracket"></i
                      ><span>ログアウト</span>
                    </a>
                  </dd>
                </dl>
              </div>
              <div v-if="!user">
                <div class="nav-title">会員の方はこちら</div>
                <div class="header-menu__body">
                  <a class="btn btn--login" v-show="!user" href="/login">
                    <span>ログイン</span>
                  </a>
                  <a
                    class="btn btn--app"
                    v-show="!user"
                    href="/s/member/register"
                  >
                    <span>新規登録</span>
                  </a>
                </div>
                <dl class="list-menu2">
                  <dt class="title">ログインせずご利用の方はこちら</dt>
                  <dd>
                    <a class="link-icon" href="/application/list">
                      <i class="fa-solid fa-calendar-check"></i
                      ><span>予約確認</span>
                    </a>
                  </dd>
                </dl>
              </div>
            </li>
            <li>
              <dl class="list-menu">
                <dt class="search">探す</dt>
                <dd>
                  <a class="link-icon" href="/">
                    <i class="fa-solid fa-plane"></i><span>国内格安航空券</span>
                  </a>
                  <a class="link-icon" href="/hotel">
                    <i class="fa-solid fa-hotel"></i><span>ホテル・旅館</span>
                  </a>
                  <a class="link-icon" href="/dp/">
                    <img
                      src="/travelist/pc/img/dynamic_package.svg"
                      alt="国内航空券+ホテル"
                      width="15"
                      height="auto"
                    /><span>国内航空券+ホテル</span>
                  </a>
                  <a class="link-icon" href="/international-air/">
                    <img
                      src="/travelist/pc/img/international_air.svg"
                      alt="海外格安航空券"
                      width="15"
                      height="auto"
                    /><span>海外格安航空券</span>
                  </a>
                  <a class="link-icon" href="/train/">
                    <span
                      class="inline-flex items-center justify-center gap-[2px] w-[15px] shrink-0"
                      style="color: #a2a2a2"
                    >
                      <svg
                        class="w-[7.875px] h-[9px]"
                        viewBox="0 0 9.1875 10.5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="currentColor"
                          d="M7.21875 0C8.30567 0 9.1875 0.881836 9.1875 1.96875V7.21875C9.1875 8.20313 8.44922 9.02344 7.50586 9.16699L8.44922 10.1104C8.59277 10.2539 8.49024 10.5 8.28516 10.5H7.48535C7.30078 10.5 7.13672 10.4385 7.01367 10.3154L5.90625 9.1875H3.28125L2.15332 10.3154C2.03027 10.4385 1.86621 10.5 1.68164 10.5H0.881836C0.676758 10.5 0.574219 10.2539 0.717774 10.1104L1.66113 9.16699C0.717774 9.02344 0 8.20313 0 7.21875V1.96875C0 0.881836 0.861328 0 1.96875 0H7.21875ZM1.3125 3.9375C1.3125 4.30664 1.59961 4.59375 1.96875 4.59375H7.21875C7.56738 4.59375 7.875 4.30664 7.875 3.9375V1.96875C7.875 1.62012 7.56738 1.3125 7.21875 1.3125H1.96875C1.59961 1.3125 1.3125 1.62012 1.3125 1.96875V3.9375ZM4.59375 7.875C5.12695 7.875 5.57813 7.44434 5.57813 6.89063C5.57813 6.35742 5.12695 5.90625 4.59375 5.90625C4.04004 5.90625 3.60938 6.35742 3.60938 6.89063C3.60938 7.44434 4.04004 7.875 4.59375 7.875Z"
                        />
                      </svg>
                      <svg
                        class="w-[8.75px] h-[8.75px]"
                        viewBox="0 0 10.2083 10.2083"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="currentColor"
                          d="M8.75 0C9.54753 0 10.2083 0.660807 10.2083 1.45833V8.75C10.2083 9.57031 9.54753 10.2083 8.75 10.2083H1.45833C0.638021 10.2083 0 9.57031 0 8.75V1.45833C0 0.660807 0.638021 0 1.45833 0H8.75ZM7.65625 7.47396V2.73438C7.65625 2.43815 7.4056 2.1875 7.10938 2.1875C6.79036 2.1875 6.5625 2.43815 6.5625 2.73438V4.55729H3.64583V2.73438C3.64583 2.43815 3.39518 2.1875 3.09896 2.1875C2.77995 2.1875 2.55208 2.43815 2.55208 2.73438V7.47396C2.55208 7.79297 2.77995 8.02083 3.09896 8.02083C3.39518 8.02083 3.64583 7.79297 3.64583 7.47396V5.65104H6.5625V7.47396C6.5625 7.79297 6.79036 8.02083 7.10938 8.02083C7.4056 8.02083 7.65625 7.79297 7.65625 7.47396Z"
                        />
                      </svg> </span
                    ><span>JR+宿泊</span>
                  </a>
                </dd>
              </dl>
              <dl class="list-menu">
                <dt class="guide">ご利用ガイド</dt>
                <dd>
                  <a class="link-icon" href="/support/flow">
                    <i class="fa-solid fa-lightbulb"></i
                    ><span>ご利用の流れ</span>
                  </a>
                  <a
                    class="link-icon"
                    href="https://tayori.com/faq/790c65b095252e9628baebfe559b377e5e73f8c9/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fa-solid fa-circle-question"></i
                    ><span>よくあるご質問</span>
                  </a>
                  <a class="link-icon" href="/support/cancel">
                    <i class="fa-solid fa-calendar-xmark"></i
                    ><span>キャンセル・変更に関して</span>
                  </a>
                  <a class="link-icon" href="/contact">
                    <i class="fa-solid fa-comments"></i
                    ><span>お問い合わせ</span>
                  </a>
                </dd>
              </dl>
            </li>
          </ul>
        </nav>
      </header>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import HeaderPointModal from '~/src_common/components/HeaderPointModal';
import CartIcon from '~/src_common/components/common/CartIcon';
import GrobalNav from '~/src_common/components/common/GrobalNav';
import Constants from '~/src_common/constants/Constants';

const RANKS = {
  0: {
    name: 'なし',
    image: '/travelist/sp/img/icon/normal_medal.svg',
  },
  1: {
    name: 'レギュラー',
    image: '/travelist/sp/img/icon/regular_medal.svg',
  },
  2: {
    name: 'ゴールド',
    image: '/travelist/sp/img/icon/gold_medal.svg',
  },
  3: {
    name: 'プラチナ',
    image: '/travelist/sp/img/icon/platinum_medal.svg',
  },
  4: {
    name: 'ダイヤモンド',
    image: '/travelist/sp/img/icon/diamond_medal.svg',
  },
};

export default {
  data() {
    return {
      isMenuOpened: false,
      isShowPointModal: false,
      isHotelTabActive: true,
      notShowCartIconScreen: [
        'ApplicationCart',
        'ApplicationConfirm',
        'ApplicationComplete',
        'ApplicationCartBackFromLogin',
        'ApplicationCartFromMeta',
        'SelectFlight',
        'SelectBackFlight',
        'SelectFlightRoundTrip',
      ],
      notShowGlobalNav: Constants.NOT_SHOW_GLOBAL_NAV_PAGES,
      notShowPcGlobalNav: Constants.NOT_SHOW_PC_GLOBAL_NAV_PAGES,
    };
  },
  computed: {
    ...mapState(['isNative']),
    ...mapGetters({
      isLoggedIn: 'member/isLoggedIn',
      user: 'member/loggedUser',
      isAgent: 'member/isAgent',
      isFromMetaSearch: 'isFromMetaSearch',
    }),
    fullName() {
      return this.user
        ? `${this.user.last_name_kana} ${this.user.first_name_kana}`
        : this.isDesktop
        ? null
        : 'ゲスト';
    },
    rank() {
      return RANKS[this.user?.rank_no ?? 0] ?? RANKS[0];
    },
    rankName() {
      return this.rank.name;
    },
    rankImage() {
      return this.rank.image;
    },
    isMenuOpenedInner: {
      get() {
        return this.isMenuOpened;
      },
      set(isMenuOpened) {
        document.body.style.overflowY = isMenuOpened ? 'hidden' : '';
        this.isMenuOpened = isMenuOpened;
      },
    },
    headerRankLink() {
      return this.isNative
        ? this.user
          ? '/mypage/'
          : '/login'
        : '/mypage/rank_guide';
    },
    isShowCartIcon() {
      return !(
        this.notShowCartIconScreen.includes(this.pageName) ||
        location.href.includes('/s/payment')
      );
    },
    isShowGlobalNav() {
      return !this.notShowGlobalNav.includes(this.pageName);
    },
    isShowPcGlobalNav() {
      return !this.notShowPcGlobalNav.includes(this.pageName);
    },
    pageName() {
      return this.$route.name || '';
    },
  },
  methods: {
    showPointModal() {
      this.isShowPointModal = true;
    },
    closePointModal() {
      this.isShowPointModal = false;
    },
  },
  components: {
    'header-point-modal': HeaderPointModal,
    'grobal-nav': GrobalNav,
    'cart-icon': CartIcon,
  },
};
</script>

<style lang="scss" scoped>
/* ===== PC版スタイル ===== */
header {
  position: relative;
}
.header {
  background: #ffffff;
  color: #04071f;
  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
  }
  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  &__right {
    display: flex;
    align-items: center;
    font-size: 14px;
    gap: 12px;
    white-space: nowrap;
  }
  &__desc {
    font-size: 10px;
    font-weight: normal;
    width: 300px;
    color: #999;
  }
  .divide {
    border-left: 1px solid #cccccc;
    height: 17px;
  }
}

.btn {
  border-radius: 25px;
  display: flex;
  height: 36px;
  padding: 0 24px;
  justify-content: center;
  align-items: center;
  position: relative;
  line-height: 1;
  cursor: pointer;
  background: #ececec;
  color: #04071f;
  font-weight: normal;
  &:hover {
    opacity: 0.6;
  }
  &:before,
  &:after {
    display: inline-flex;
    font-family: 'Font Awesome 6 Free';
    font-weight: 900;
    font-size: 12px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 12px;
  }
  &:before {
    right: 12px;
    margin-right: 0.5em;
  }
  &:after {
    position: absolute;
    right: 12px;
  }
  &--signin {
    &:before {
      content: '\f2f6';
    }
  }
}
.btn-txt {
  font-size: 14px;
  color: #04071f;
  display: flex;
  gap: 4px;
  cursor: pointer;
  font-weight: normal;
  &:hover {
    opacity: 0.6;
  }
  &:before,
  &:after {
    display: inline-flex;
    font-family: 'Font Awesome 6 Free';
    font-weight: 900;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 14px;
    color: #a2a2a2;
  }
  &--signup:before {
    content: '\f234';
  }
  &--booking:before {
    content: '\f274';
  }
  &--user:before {
    content: '\f007';
  }
  &--heart:before {
    content: '\f004';
  }
  &--usage:after {
    content: '\f107';
  }
  &--detail {
    text-decoration: none;
    &:after {
      content: '\f054';
      padding-left: 0.5em;
    }
  }
  &--mypage {
    color: #0956e6;
    &::before,
    &::after {
      color: #a2a2a2;
    }
    span {
      color: #04071f;
    }
  }
}
.dd_menu {
  position: relative;
  padding: 20px 0;
  &__nav {
    position: absolute;
    list-style: none;
    font-size: 12px;
    z-index: 50;
    background: #fff;
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 3px #0000006b;
    transform: translate(-50%, 0);
    left: 50%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    display: none;
    &__item {
      color: #04071f;
      white-space: nowrap;
      font-weight: normal;
      line-height: 2;
      i {
        color: #a2a2a2;
        margin-right: 0.5em;
      }
      &:hover {
        text-decoration: underline;
      }
    }
    &:before,
    &:after {
      position: absolute;
      top: -10px;
      left: 50%;
      content: '';
      transform: translate(-50%, 0px);
      height: calc(tan(60deg) * 13px / 2);
      width: 16px;
      -webkit-clip-path: polygon(50% 0, 100% 100%, 0 100%);
      clip-path: polygon(50% 0, 100% 100%, 0 100%);
    }
    &:before {
      background: #ddd;
      margin-top: -2px;
    }
    &:after {
      background: #fff;
    }
  }
  &:hover &__nav {
    display: flex;
  }
}
.point-link-wrap {
  position: relative;
  &:hover {
    .point-link {
      opacity: 0.8;
    }
  }
}
.point-link-btn {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.point-link {
  display: flex;
  align-items: center;
  background: #ecf6fc;
  border-radius: 14px;
  line-height: 1;
  padding: 8px 16px;
  font-size: 12px;
  color: #04071f;
  img {
    width: 12px;
    margin-right: 4px;
  }
  span {
    font-weight: bold;
  }
}
.container-wide {
  width: 1140px;
  margin: 0 auto;
}
.agent-label {
  background: #e6f0ff;
  color: #0956e6;
  font-size: 10px;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 4px;
  line-height: 1;
  white-space: nowrap;
}

/* ===== SP版スタイル ===== */
.user-point {
  background: #2b2b2b;
  border-radius: 14px;
  font-size: 10px;
  line-height: 20px;
  padding: 0 8px;
  color: #ffffff;
  display: flex;
  align-items: center;
  img {
    width: 10px;
    height: 10px;
    vertical-align: text-top;
    margin-right: 4px;
  }
}
.heading-point {
  position: absolute;
  right: 48px;
  top: 50%;
  transform: translateY(-50%);
}

.menu-button {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 130;
  width: 48px;
  height: 48px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-button span {
  display: block;
  position: relative;
  background: #04071f;
  width: 24px;
  height: 2px;
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 24px;
    height: 2px;
    background: #04071f;
    transition: transform 0.3s ease;
  }
  &:before {
    top: -8px;
  }
  &:after {
    top: 8px;
  }
}

.sp {
  .header {
    position: relative;
  }
  .header-logo2 {
    margin-left: auto;
    margin-right: auto;
    display: block;
    height: 32px;
    width: 120px;
    padding-top: 12px;
    padding-bottom: 4px;
    img {
      width: 100%;
    }
  }
  .index-tab2 {
    background: #1b398d;
    color: #fff;
    display: flex;
    width: 100%;
    list-style: none;
    &__item {
      flex: 1;
    }
    &__tab {
      color: #fff;
      display: flex;
      flex-flow: column;
      align-items: center;
      font-weight: normal;
      height: 60px;
      justify-content: center;
      font-size: 12px;
      gap: 4px;
      padding-top: 2px;
      i {
        margin-top: 3px;
        font-size: 20px;
      }
      &.router-link-active {
        background: #0956e6;
      }
    }
  }
  .user-point {
    margin-left: auto;
    color: #04071f;
    background-color: #ecf6fc;
  }
  .header-menu {
    height: 100vh;
    overflow: scroll;
  }
  .header-menu {
    &__body {
      padding: 20px;
      display: flex;
      flex-flow: column;
      gap: 8px;
    }
  }
  .nav2 {
    position: fixed;
    top: 0;
    height: 100%;
    width: 276px;
    overflow: hidden;
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: rgba(19, 19, 19, var(--tw-text-opacity));
    right: -2500px;
    z-index: 125;
    box-shadow: 0 0 15px 0 #606060;
    transition: right 0.6s cubic-bezier(0.19, 1, 0.22, 1);
  }
  .opened {
    .nav2 {
      right: 0;
    }
    .menu-button {
      right: 276px;
    }
    .menu-button-icon {
      background: transparent;
      &:before {
        top: 0;
        transform: rotate(45deg);
      }
      &:after {
        top: 0;
        transform: rotate(-45deg);
      }
    }
  }
  .list-menu {
    dt {
      background: #ececec;
      font-weight: bold;
      display: flex;
      gap: 8px;
      height: 30px;
      padding: 0 8px;
      font-size: 12px;
      align-items: center;
      &:before {
        font-family: 'Font Awesome 6 Free';
        font-weight: 600;
        font-size: 14px;
        color: #a2a2a2;
      }
      &.search:before {
        content: '\f002';
      }
      &.guide:before {
        content: '\f02d';
      }
    }
    dd {
      background: #ececec;
      display: flex;
      flex-flow: column;
      gap: 1px;
    }
  }
  .list-menu2 {
    background: #d6e8fd;
    padding: 14px 16px 12px;
    dt.title {
      font-size: 12px;
      font-weight: bold;
      color: #04071f;
      margin-bottom: 1em;
    }
    dt.mypage {
      margin-top: 5px;
      font-size: 12px;
      line-height: 1.4;
      margin-bottom: 15px;
      .user-name2 {
        font-weight: bold;
        font-size: 20px;
        padding-right: 3px;
        &:before {
          font-family: 'Font Awesome 6 Free';
          margin-right: 5px;
          font-size: 13px;
          font-weight: 600;
          vertical-align: middle;
          content: '\f007';
          color: #2060f0;
        }
      }
    }
    dd {
      background: #ececec;
      overflow: hidden;
      border-radius: 4px;
      display: flex;
      flex-flow: column;
      gap: 1px;
    }
  }
  a.link-icon {
    display: flex;
    align-items: center;
    font-size: 13px;
    height: 45px;
    color: #04071f;
    padding: 0 16px;
    background: #fff;
    font-weight: normal;
    position: relative;
    gap: 8px;
    i {
      color: #a2a2a2;
      font-size: 14px;
    }
    &:after {
      font-weight: 600;
      font-family: 'Font Awesome 6 Free';
      position: absolute;
      color: #0956e6;
      content: '\f105';
      right: 12px;
    }
  }
  .nav-title {
    background: #1b398d;
    color: #fff;
    display: flex;
    gap: 4px;
    height: 48px;
    align-items: center;
    padding: 0 16px;
    &::before {
      font-family: 'Font Awesome 6 Free';
      font-weight: 600;
      content: '\f4fc';
    }
  }
  .overlay {
    background-color: rgba(0, 0, 0, 0.7);
  }
  .btn {
    display: flex;
    border-radius: 2rem;
    height: 48px;
    justify-content: center;
    align-items: center;
    font-weight: normal;
    gap: 8px;
    font-size: 14px;
    &:before {
      font-family: 'Font Awesome 6 Free';
      font-weight: 600;
    }
    &--login {
      background: #0956e6;
      color: #fff;
      &:before {
        content: '\f090';
      }
    }
    &--app {
      border: 1px solid #0956e6;
      background: #fff;
      color: #0956e6;
      &:before {
        content: '\f234';
      }
    }
  }
}
.headerRank {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #000;
  padding: 8px 12px;
  width: 100%;
  &--menu {
    justify-content: flex-end;
  }
  &__rank {
    display: flex;
    align-items: center;
  }
  &__rankName {
    margin-right: 5px;
  }
  &__rankImage {
    img {
      vertical-align: middle;
    }
  }
}
</style>
